import { EnumToArray } from '../../../utils/enumToArray';

enum Appearance {
  Light = 'light',
  Dark = 'dark',
  Color = 'color',
}

enum Size {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}

enum State {
  Error = 'error',
  Disabled = 'disabled',
  Default = 'default',
}

export const PTZCheckboxConfigList = {
  Appearance: EnumToArray([Appearance]),
  Size: EnumToArray([Size]),
  State: EnumToArray([State]),
};

export const PTZCheckboxConfig = {
  Appearance,
  Size,
  State,
};
